import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';

const Login = ({ onLogin, error }) => {
    const { t, language, setLanguage, isRtl } = useLanguage();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await onLogin(email, password);
        setLoading(false);
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f1f2f4',
            padding: 20,
            direction: isRtl ? 'rtl' : 'ltr'
        }}>
            {/* Language Switcher on Login Page */}
            <div style={{ position: 'absolute', top: 20, [isRtl ? 'left' : 'right']: 20, display: 'flex', gap: 10 }}>
                <button onClick={() => setLanguage('english')} style={{
                    padding: '6px 12px', border: 'none', borderRadius: 6,
                    background: language === 'english' ? '#1976d2' : '#fff',
                    color: language === 'english' ? '#fff' : '#1a1c1d',
                    fontSize: 12, fontWeight: 600, cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>English</button>
                <button onClick={() => setLanguage('arabic')} style={{
                    padding: '6px 12px', border: 'none', borderRadius: 6,
                    background: language === 'arabic' ? '#1976d2' : '#fff',
                    color: language === 'arabic' ? '#fff' : '#1a1c1d',
                    fontSize: 12, fontWeight: 600, cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>العربية</button>
            </div>

            <div style={{
                width: '100%',
                maxWidth: 400,
                background: '#fff',
                borderRadius: 12,
                padding: '40px 32px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                border: '1px solid #e1e3e5'
            }}>
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    {/* Logo Icon */}
                    <img src="/omniTraceLogo.png" alt="OmniTraceX" style={{
                        width: 80, height: 80,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        display: 'block',
                        margin: '0 auto 16px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                        border: '2px solid #f1f2f4'
                    }} />

                    <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#1a1c1d' }}>OmniTraceX</h1>
                    <p style={{ margin: '8px 0 0', color: '#6d7175', fontSize: 14 }}>{t.sign_in_to_continue}</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 20 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#1a1c1d', marginBottom: 6, textAlign: isRtl ? 'right' : 'left' }}>{t.email}</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: 6,
                                outline: 'none', transition: 'border 0.2s', boxSizing: 'border-box', textAlign: isRtl ? 'right' : 'left'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#1976d2'}
                            onBlur={(e) => e.target.style.borderColor = '#c9cccf'}
                            required
                        />
                    </div>

                    <div style={{ marginBottom: 24 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#1a1c1d', marginBottom: 6, textAlign: isRtl ? 'right' : 'left' }}>{t.password}</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: 6,
                                outline: 'none', transition: 'border 0.2s', boxSizing: 'border-box', textAlign: isRtl ? 'right' : 'left'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#1976d2'}
                            onBlur={(e) => e.target.style.borderColor = '#c9cccf'}
                            required
                        />
                    </div>

                    <button type="submit" disabled={loading} style={{
                        width: '100%', padding: '12px', borderRadius: 6, border: 'none',
                        background: '#1976d2', color: '#fff', fontWeight: 600, fontSize: 14,
                        cursor: loading ? 'wait' : 'pointer', transition: 'background 0.2s',
                        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        marginBottom: error ? 12 : 0
                    }}
                        onMouseOver={(e) => !loading && (e.target.style.background = '#1565c0')}
                        onMouseOut={(e) => !loading && (e.target.style.background = '#1976d2')}
                    >
                        {loading ? <div className="dots-loading"><span></span><span></span><span></span></div> : t.sign_in}
                    </button>
                    {error && (
                        <div style={{
                            fontSize: 13, color: '#d82c0d', textAlign: 'center',
                            marginTop: 8, fontWeight: 500, background: '#fff5f5',
                            padding: '8px 12px', borderRadius: 6, border: '1px solid #fed7d7'
                        }}>
                            {error}
                        </div>
                    )}
                </form>

                <div style={{ marginTop: 24, paddingTop: 24, borderTop: '1px solid #f1f1f1', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 13, color: '#6d7175' }}>
                        {t.dont_have_account} <span style={{ color: '#1976d2', fontWeight: 600, cursor: 'pointer' }}>{t.contact_admin}</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
